{
  "name": "trtc-sdk-v5",
  "version": "5.17.0",
  "description": "TRTC Web SDK",
  "main": "dist/trtc.js",
  "module": "dist/trtc.esm.js",
  "types": "dist/npm-package/index.d.ts",
  "dependencies": {
    "@trtc/js-sdk-types": "workspace:*",
    "@trtc/video-decoder": "file:../../plugins/video-decoder",
    "afsm": "2.4.9",
    "core-js": "^3.30.0",
    "eventemitter3": "4.0.7",
    "fastrx": "^3.3.5",
    "jv4-decoder": "^1.1.0",
    "sdp-transform": "2.14.1",
    "trtc-js-sdk-core": "workspace:*",
    "trtc-js-sdk-wasm": "workspace:*",
    "trtc-js-sdk-webrtc": "workspace:*",
    "webrtc-adapter": "^9.0.4"
  },
  "scripts": {
    "dev": "node ./build/esbuild -f iife",
    "dev:vue": "node ./build/esbuild --vue",
    "dev:wasm": "node ./build/esbuild --room wasm",
    "dev:ktv": "node ./build/esbuild -f esm -d ../../examples/karaoke/node_modules/trtc-sdk-v5/  -a ../dist",
    "esbuild": "node ./build/esbuild",
    "esbuild:prd": "node ./build/esbuild --prd",
    "esbuild:prd:iife": "node ./build/esbuild --prd -f iife",
    "esbuild:example:blur:dev": "node ./build/esbuild -f iife -d ../../examples/api-cloud-next/background-blur/v5-ziyan -n srtc ",
    "esbuild:example:blur": "node ./build/esbuild --prd -f iife -d ../../examples/api-cloud-next/background-blur/v5-ziyan -n srtc ",
    "esbuild:wasm": "node ./build/esbuild --room wasm --prd",
    "esbuild:wasm:iife": "node ./build/esbuild --room wasm --prd -f iife",
    "babel": "babel dist/trtc-cloud.js --config-file --out-file dist/trtc.js",
    "build:wasm": "node ./build/esbuild --room wasm --prd && rollup -c build/rollup.config.mjs",
    "build": "node ./build/build.js",
    "build:vision": "esbuild --bundle --platform=browser --format=iife --global-name=Vision --target=es2020 --outfile=./dist/npm-package/assets/mediapipe/vision.js ../sdk-core/src/manager/vision.ts",
    "tag": "node ./build/tag.js",
    "deprecate-beta-version": "node ./build/deprecate-beta-version.js",
    "version": "node ./build/update-package-version.js",
    "rollup": "rollup -c build/rollup.config.js",
    "lint": "./node_modules/.bin/eslint ./src",
    "fix": "./node_modules/.bin/eslint ./src --fix",
    "docs": "pnpm run docs:tsc || pnpm run docs:clean && pnpm run docs:build:zh-cn && pnpm run docs:build:en",
    "docs:build:zh-cn": "jsdoc -c build/jsdoc/jsdoc-zh-cn.json && node ./build/jsdoc/fix-doc-zh-cn.js && node ./build/jsdoc/generate-doc-markdown.js --lang zh-cn",
    "docs:build:en": "jsdoc -c build/jsdoc/jsdoc.json && node ./build/jsdoc/fix-doc.js && node ./build/jsdoc/generate-doc-markdown.js --lang en",
    "docs:markdown": "node ./build/jsdoc/generate-doc-markdown.js --lang zh-cn && node ./build/jsdoc/generate-doc-markdown.js --lang en",
    "docs:markdown:zh-cn": "node ./build/jsdoc/generate-doc-markdown.js --lang zh-cn",
    "docs:markdown:en": "node ./build/jsdoc/generate-doc-markdown.js --lang en",
    "docs:revert-translate": "node ./build/jsdoc/revert-translate-doc2js.js > ./docs/en/translate/convert.output",
    "docs:clean": "node ./build/jsdoc/clean-doc.js",
    "docs:tsc": "tsc --outDir dist --target esnext src/main.ts src/common/error-code.ts src/common/rtc-error.ts ../sdk-core/src/common/rtc-error.ts",
    "test": "node ./build/test.js",
    "test:safari": "bash -c 'pkill -9 Safari; pkill -9 osascript; (sleep 3; osascript ../../scripts/click-safari.scpt) & OSA_PID=$!; node ./build/test.js --safari --log=4 \"$@\"; kill $OSA_PID' --",
    "test:safari:batch": "node ./build/test-safari-batch.js",
    "test:mpc": "node ./build/test.js --enableSPC=false",
    "test:mpc:debug": "node ./build/test.js --enableSPC=false --debug=true",
    "test:coverage": "node ./build/test.js --coverage=true",
    "test:debug": "node ./build/test.js --debug=true",
    "test:wasm": "node ./build/test.js --wasm=true",
    "test:debug:wasm": "node ./build/test.js --debug=true --wasm=true",
    "dts": "ts-node --esm ../../scripts/dts-generator.mts --out dist/npm-package/index.d.ts --depProject ../sdk-core --extern ./core.d.ts"
  },
  "devDependencies": {
    "@babel/preset-env": "^7.21.4",
    "@rollup/plugin-babel": "^6.0.3",
    "@rollup/plugin-commonjs": "^24.0.1",
    "@rollup/plugin-json": "^4.1.0",
    "@rollup/plugin-node-resolve": "^13.3.0",
    "@rtc-plugin/basic-beauty": "workspace:*",
    "@rtc-plugin/beauty": "workspace:*",
    "@rtc-plugin/cdn-streaming": "workspace:*",
    "@rtc-plugin/cross-room": "workspace:*",
    "@rtc-plugin/custom-encryption": "workspace:*",
    "@rtc-plugin/device-detector": "workspace:*",
    "@rtc-plugin/virtual-background": "workspace:*",
    "@rtc-plugin/watermark": "workspace:*",
    "@trtc/cloud-sdk-types": "^1.0.1",
    "@types/dom-mediacapture-transform": "^0.1.1",
    "@types/dom-webcodecs": "^0.1.13",
    "@typescript-eslint/eslint-plugin": "^5.40.1",
    "@typescript-eslint/parser": "^5.40.1",
    "dayjs": "^1.11.13",
    "esbuild": "^0.25.0",
    "eslint": "^8.21.0",
    "eslint-config-tencent": "^1.0.4",
    "eslint-plugin-prettier": "^4.2.1",
    "jsdoc": "^3.6.2",
    "jsdoc-to-markdown": "^9.1.3",
    "jszip": "^3.10.1",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "^2.2.0",
    "karma-coverage": "^2.1.0",
    "karma-esbuild": "^2.3.0",
    "karma-jasmine": "^2.0.1",
    "karma-jasmine-diff-reporter": "^2.0.1",
    "karma-parallel": "^0.3.1",
    "karma-rollup-preprocessor": "^7.0.0",
    "karma-safari-launcher": "^1.0.0",
    "karma-spec-reporter": "0.0.32",
    "karma-typescript": "^5.5.4",
    "prettier": "^2.7.1",
    "pretty": "^2.0.0",
    "replace": "^1.2.2",
    "rollup": "^2.78.1",
    "rollup-plugin-copy": "^3.4.0",
    "rollup-plugin-polyfill-node": "^0.10.2",
    "rollup-plugin-progress": "^1.1.2",
    "rollup-plugin-terser": "^7.0.2",
    "typescript": "~5.0.4",
    "yargs": "^17.5.1"
  }
}